import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/incms';
const baseEndpoint2 = 'v1/channels';

const IncmsService = {

  deleteSendService( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}/sendservices` )
  },

  getCaseReasons( id ) {
    return axios
      .get( `${baseEndpoint}/${id}/reasons` )
  },

  getCaseTypes() {
    return axios
      .get( `${baseEndpoint}/types` )
  },

  getProfile( id ) {
    return axios
      .get( `${baseEndpoint}/${id}/profile` )
  },

  getRccsData() {
    return axios
      .get( `${baseEndpoint}/rccs/general` )
  },

  getRccsGroup( contractMask ) {
    return axios
      .get( `${baseEndpoint}/rccs/groups/${contractMask}` )
  },

  getRccsTypes( contractMask, group ) {
    return axios
      .get( `${baseEndpoint}/rccs/group/types/${contractMask}/${group}` )
  },


  getImsData() {
    return axios
      .get( `${baseEndpoint}/ims/general` )
  },

  getIncidentTypes() {
    return axios
      .get( `${baseEndpoint}/incident-types` )
  },
  
  getIncidentSubTypes( incidentType ) {
    return axios
      .get( `${baseEndpoint}/incident-types/${incidentType}/subtypes` )
  },

  getLandmark( id ) {
    return axios
      .get( `${baseEndpoint}/ims/${id}/landmark` )
  },

  getRccsOfficeEmployee( id ) {
    return axios
      .get( `${baseEndpoint}/${id}/rccs/employees` )
  },

  getRccsOffices( id ) {
    return axios
      .get( `${baseEndpoint}/${id}/rccs/office` )
  },

  getSendServices( accountId, params ) {
    return axios
      .get( `${baseEndpoint}/${accountId}/sendservices`, { params } )
  },

  getSendServiceTypes() {
    return axios
      .get( `${baseEndpoint}/sendservices/types` )
  },

  linkCustomer( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}/link/customer`, data )
  },

  unLink( id, data ) {
    return axios
      .put( `${baseEndpoint2}/${id}/unlink`, data )
  },

  saveSendService( id, data ) {
    return axios
      .post( `${baseEndpoint}/${id}/sendservices`, data )
  },

  searchProfile( params ) {
    return axios
      .get( `${baseEndpoint}/searchprofile`, { params } )
  },

  updateSendService( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}/sendservices`, data )
  },

  updateMainSendService( data ) {
    return axios
      .put( `${baseEndpoint}/mainsendservices`, data )
  },

  getClientFolderData( account, locale ) {
    return axios
      .get( `v1/incms-client-folder/${account}/account-data?locale=${locale}` )
  },

  getClientFolderMovement( id, type ) {
    return axios
      .get( `v1/incms-client-folder/${id}/movement-detail/${type}` )
  },

  getClientFolderOutageArea( account ) {
    return axios
      .get( `v1/incms/ims/${account}/outage-in-area` )
  },


  getOutages( account ) {
    return axios
      .get( `v1/incms/account/${account}/outages` )
  },

  getStatement( id, params ) {
    console.log(params)
    return axios
      .get( `v1/incms-client-folder/${id}/statement-pdf`, { params } )
  },

  getProvince(  ) {
    return axios
      .get( `${baseEndpoint}/ims/province` )
  },

  getDistric( idProvince ) {
    return axios
      .get( `${baseEndpoint}/ims/${idProvince}/district` )
  },

  getDivision( idDistrict ) {
    return axios
      .get( `${baseEndpoint}/ims/${idDistrict}/division` )
  },

  getLocation( idDivision ) {
    return axios
      .get( `${baseEndpoint}/ims/${idDivision}/location` )
  },

  getStreet( idLocation ) {
    return axios
      .get( `${baseEndpoint}/ims/${idLocation}/street` )
  },

  searchComplaint( idReference ) {
    return axios
      .get( `${baseEndpoint}/ims/${idReference}/details` )
  },
  
  searchComplaintLEC( params ) {
    
    return axios
      .get( `${baseEndpoint}/outages`, {params} )
  },

  getLocations() {
    return axios
      .get( `${baseEndpoint}/outages/all-locations` )
  },

  getOtherInfo() {
    return axios
      .get( `${baseEndpoint}/other/information` )
  },

  getWeatherConditions() {
    return axios
      .get( `${baseEndpoint}/weather/conditions` )
  },

  getContractNumberInfo(params) {
    return axios
      .get( `${baseEndpoint}/work-request/customer-search/contract-number`, {params} )
  },
  updateSendServiceLEC( data ) {
    return axios
      .put( `${baseEndpoint}/work-request/customer/profile`, data )
  },
};

export default IncmsService;



// WEBPACK FOOTER //
// ./services/IncmsService.js